export const constants = {
  appName: "Lucie's Book",
  artBookPriceInCent: 4900,
  artBookShippingFeeInCent: 0,
  priceCurrencySymbol: '$',
  searchParams: { photoBookId: 'photoBookId', orderId: 'orderId', checkoutSessionId: 'sessionId', theme: 'theme' },
} as const
